<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <v-autocomplete searchable
                                multiple
                                chips
                                clearable
                                dense
                                outlined
                                v-model.lazy="selectedMunicipalityItems"
                                :items="itemsMunicipality"
                                item-value="id"
                                item-text="municipalityName"
                                :menu-props="{ maxHeight: '150' }"
                                style="z-index: 999999"
                                :label="$t('Select')">
                    <template v-slot:prepend-item>
                        <v-list-item @click="selectAllItems">
                            <v-list-item-content>{{ $t('SelectAll') }}</v-list-item-content>
                        </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                        <v-list-item-content>
                            <h4>{{ item.municipalityName }}</h4>
                        </v-list-item-content>
                    </template>
                    <template v-slot:selection="{ item }">
                        <v-chip :key="item.id" close @click:close="removeItem(item.id)">
                            {{ item.municipalityName }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import StructuresService from '@/services/StructuresService.js'

    export default {
        data() {
            return {
                selectedMunicipalityItems: [],
                itemsMunicipality: [],
            }
        },
        created() {
            this.getMunicipality()
        },
        methods: {
            getMunicipality() {
                StructuresService.listMunicipalities().then((res) => {
                    if (res.data) {
                        this.itemsMunicipality = res.data.map(item => ({
                            id: item.id,
                            municipalityName: item.name
                        }))
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            removeItem(id) {
                const index = this.selectedMunicipalityItems.indexOf(id)
                if (index !== -1) {
                    this.selectedMunicipalityItems.splice(index, 1)
                }
            },
            selectAllItems() {
                this.selectedMunicipalityItems = this.itemsMunicipality.map(item => item.id)
            },
        }
    }
</script>

<style scoped>
    /* Optional: Style the chips if needed */
    .v-chip {
        cursor: pointer;
    }
</style>
